import styled from 'styled-components'

export const StyledCameraDisplayContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledCameraDisplayVideo = styled.video`
  width: 400px;
  height: 400px;
	position: absolute;
  object-fit: cover;
  transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
`;

export const StyledCameraDisplayControlsContainer = styled.div`
  width: 100%;
  height: 100px;
`;